<template>
    <section>
        <div class="form-box d-flex justify-content-center align-items-center">
            <div class="card-login text-white position-relative p-4">

                <button type="button" class="btn btn-light position-absolute top-0 end-0 m-2"
                    @click="$router.push('/loginPostulante')">
                    <i class="bi bi-arrow-return-left"></i>
                </button>

                <!-- Logo -->
                <div class="text-center mb-3">
                    <img src="../../../assets/logoLogin/topas.png" alt="Logo" />
                </div>

                <h4 class="text-center mb-4">REGISTRARSE</h4>

                <!-- Formulario -->
                <form class="w-100" @submit.prevent="registrarUsuario">

                    <!-- Documento -->
                    <div class="d-flex gap-2 mb-2">
                        <div class="input-container flex-grow-1">
                            <i class="bi bi-card-text text-secondary"></i>
                            <select v-model="usuario.tipoDocumento" class="form-select" required>
                                <option value="" disabled>Tipo de Documento</option>
                                <option v-for="tipo in tipoDocumentos" :key="tipo.id" :value="tipo.id">
                                    {{ tipo.nombre }}
                                </option>
                            </select>
                        </div>

                        <div class="input-container flex-grow-2">
                            <i class="bi bi-123 text-secondary"></i>
                            <input type="number" placeholder="Número de Documento" v-model="usuario.numeroDocumento"
                                @input="noEspaciosInicio('numeroDocumento')" required class="form-control" />
                        </div>
                    </div>

                    <!-- Nombre -->
                    <div class="input-container mb-2">
                        <i class="bi bi-person-fill text-secondary"></i>
                        <input type="text" placeholder="Nombre" v-model="usuario.nombre"
                            @input="noEspaciosInicio('nombre')" required class="form-control" />
                    </div>

                    <!-- Apellido Paterno -->
                    <div class="input-container mb-2">
                        <i class="bi bi-person-fill text-secondary"></i>
                        <input type="text" placeholder="Apellido Paterno" v-model="usuario.apellidoPaterno"
                            @input="noEspaciosInicio('apellidoPaterno')" required class="form-control" />
                    </div>

                    <!-- Apellido Materno -->
                    <div class="input-container mb-2">
                        <i class="bi bi-person-fill text-secondary"></i>
                        <input type="text" placeholder="Apellido Materno" v-model="usuario.apellidoMaterno"
                            @input="noEspaciosInicio('apellidoMaterno')" required class="form-control" />
                    </div>

                    <!-- Fecha nacimiento -->
                    <div class="input-container mb-2">
                        <i class="bi bi-calendar-fill text-secondary"></i>
                        <input type="date" v-model="usuario.fechaNacimiento" required class="form-control" />
                    </div>
                    <!-- Celular -->
                    <div class="input-container flex-grow-2 mb-2">
                        <i class="bi bi-123 text-secondary"></i>
                        <input type="number" placeholder="Número de Celular" v-model="usuario.celular"
                            @input="noEspaciosInicio('celular')" required class="form-control" />
                    </div>

                    <!-- Correo -->
                    <div class="input-container mb-2">
                        <i class="bi bi-envelope-fill text-secondary"></i>
                        <input type="email" placeholder="correo personal" v-model="usuario.correo"
                            @input="noEspaciosInicio('correo')" required class="form-control" />
                    </div>

                    <!-- Contraseña 
                    <div class="input-container mb-3">
                        <i class="bi bi-key-fill text-secondary"></i>
                        <input type="password" placeholder="Contraseña" v-model="usuario.contrasena"
                            @input="noEspaciosInicio('contrasena')" required class="form-control"
                            data-bs-toggle="tooltip" title="Se acepta el DNI como contraseña" />

                    </div>-->


                    <!-- Botón -->
                    <button type="submit" class="btn btn-success w-100">
                        Registrarse
                    </button>

                </form>
            </div>
        </div>
    </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
    name: "SolimanoFormularioRegistroView",
    data() {
        return {
            usuario: {
                tipoDocumento: "",
                numeroDocumento: "",
                nombre: "",
                apellidoPaterno: "",
                apellidoMaterno: "",
                fechaNacimiento: "",
                correo: "",
                celular: ""
            },
            tipoDocumentos: [
                { id: "001", nombre: "DNI" },
                { id: "004", nombre: "CARNET DE EXTRANJERIA" }
            ]
        };
    },
    methods: {
        noEspaciosInicio(campo) {
            if (this.usuario[campo]) {
                this.usuario[campo] =
                    this.usuario[campo].replace(/^\s+/, "");
            }
        },


        registrarUsuario() {
            if (
                !this.usuario.tipoDocumento ||
                !this.usuario.numeroDocumento ||
                !this.usuario.nombre ||
                !this.usuario.apellidoPaterno ||
                !this.usuario.apellidoMaterno ||
                !this.usuario.fechaNacimiento ||
                !this.usuario.celular ||
                !this.usuario.correo
            ) {
                Swal.fire({
                    title: "Campos incompletos",
                    text: "Por favor, complete todos los campos obligatorios, incluyendo el tipo de documento.",
                    icon: "warning",
                    confirmButtonText: "Aceptar"
                });
                return;
            }

            // Creamos la constante para asegurar que los nombres de las propiedades 

            // coincidan con los que espera el modelo 'Usuario' en C#

            const Guardar = {

                // LADO DERECHO: Es el valor que viene de tu formulario en
                tipoDocumento: this.usuario.tipoDocumento,
                usuDocumento: this.usuario.numeroDocumento,
                usuApePaterno: this.usuario.apellidoPaterno,
                usuApeMaterno: this.usuario.apellidoMaterno,
                usuNombres: this.usuario.nombre,
                correoUsu: this.usuario.correo,
                //  // <--- CAMBIADO a 'correoUsu' para que C# lo 
                celular: this.usuario.celular, // <--- Asegúrate que en C# sea 'celular'
                usuFecNacimiento: this.usuario.fechaNacimiento

            };

            this.axios

                .post("Usuario/RegistrarUsuario", Guardar)

                .then((r) => {

                    // Desestructuramos la respuesta de la API

                    // exito: booleano que indica si se procesó correctamente

                    // mensaje: el texto que viene directamente desde el Stored Procedure
                   console.log(r.data);
                    const { exito, mensaje } = r.data;
                    if (exito) {
                        Swal.fire({
                            title: "¡Registro exitoso!",
                            text: mensaje, // Muestra el mensaje de la DB (Usuario creado, etc.)
                            icon: "success",
                            confirmButtonText: "Aceptar"
                        });
                        this.usuario = {
                            tipoDocumento: "",
                            numeroDocumento: "",
                            nombre: "",
                            apellidoPaterno: "",
                            apellidoMaterno: "",
                            fechaNacimiento: "",
                            correo: "",
                            celular: ""
                        };
                    } else {
                        Swal.fire({
                            title: "Atención",
                            text: mensaje || "No se pudo completar el registro.",
                            icon: "warning",
                            confirmButtonText: "Reintentar"
                        });
                    }
                })

                .catch((error) => {
                    console.error("Error en la petición:", error);
                    // Manejo de errores de red o excepciones del servidor (500)
                    Swal.fire({
                     title: "Error de Servidor",
                        text: "Ocurrió un problema al comunicarse con la API.",
                        icon: "error",
                        confirmButtonText: "Cerrar"
                    });
                });
        }
    }
};

</script>
<style scoped>
section {
    position: relative;
    min-height: 100dvh;
    width: 100vw;

    display: flex;
    justify-content: center;
    align-items: center;

    background-image: url("../../../assets/logoLogin/grande.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
}

section::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(0, 44, 93, 0.93);
    z-index: 1;
}

section>* {
    position: relative;
    z-index: 2;
}

.card-login {
    width: 100%;
    max-width: 550px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(255, 255, 255, 0.6);
    border-radius: 14px;
    backdrop-filter: blur(6px);
    padding: 2rem;
    position: relative;
}

.input-container {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: rgba(255, 255, 255, 0.95);
    padding: 0.25rem 0.45rem;
    border-radius: 6px;
}

.input-container i {
    font-size: 1.1rem;
}

input,
select {
    flex: 1;
    line-height: 28px;
    padding: 2px 6px;
    border: none;
    font-size: 0.9rem;
    outline: none;
    background-color: transparent;
}

button.btn {
    padding: 0.45rem;
    font-size: 0.95rem;
}

.card-login img {
    width: 95px;
    height: 95px;
}

@media (max-width: 570px) {
    .card-login {
        max-width: 90%;
        padding: 1.5rem;
    }
}
</style>
